<div
  [ngClass]="
    theme === GrandTotalTheme.RENEWED
      ? 'nordic-blue-900-bg border-bottom border-left border-right rounded-bottom-large pr-small-x pr-xsmall-y'
      : 'mr-xsmall-t white-bg border rounded-large pr-small'
  "
  class="grand-total"
>
  <h2 [ngClass]="theme === GrandTotalTheme.RENEWED ? 'white-text' : 'nordic-blue-900-text'" class="font-heading-5 flex">
    <span class="flex-1 flex--basis0">{{ 'price.grandTotal' | finLocalization }}</span>
    <span class="flex-1 flex--basis0 flex flex--wrap flex--end align-right">
      <span class="strike-through pr-xxsmall-r" *ngIf="originalTotalPrice$ | async as originalTotalPrice">{{
        originalTotalPrice | finPrice: { useSymbol }
      }}</span>
      <span data-testid="total-points-and-price" *ngIf="totalPoints$ | async as points">
        <span data-testid="total-points" class="nowrap">
          {{ ('award.points' | finLocalization: { pointsAmount: points || 0 | finPoints }) + '&nbsp;+&nbsp;' }}</span
        >
        {{ totalPrice$ | async | finPrice: { useSymbol } }}
      </span>
      <span *ngIf="(totalPoints$ | async) === null">{{ totalPrice$ | async | finPrice: { useSymbol } }}</span>
    </span>
  </h2>
</div>
